module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lhmhy"))).then(() => parcelRequire('d0iPb'));